import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {RootState} from '../store';
import "./AboutTheAppPage.css"

type AboutTheAppPageProps = RouteComponentProps<{ contestId: string, tab: string }> & typeof mapDispatchToProps;
type State = {
  version: string;
}

class AboutTheAppPage extends React.Component<AboutTheAppPageProps, State> {
  constructor(props: AboutTheAppPageProps) {
    super(props);
    this.state = {
      version: "unknown"
    }
  }

  componentDidMount(): void {
    fetch('/version.json').then(response => response.json().then(body => this.setState({version: body.version})));
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>Contactgegevens</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonImg src="assets/img/lrv-aachen-cropped.jpg"/>
          <IonList>
            <IonItem>
              <IonIcon name="pin" slot="start"></IonIcon>
              <IonLabel>Waversebaan 99<br/>3050 Oud-Heverlee</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon name="mail" slot="start"></IonIcon>
              <IonLabel>info@lrv.be</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon name="call" slot="start"></IonIcon>
              <IonLabel>016/47 99 60</IonLabel>
            </IonItem>
            <IonItem lines="none">
              <IonIcon name="hammer" slot="start"></IonIcon>
              <IonLabel>
                <small>Versie {this.state.version}</small>
              </IonLabel>
            </IonItem>
          </IonList>

          <div className="socialButtons">
            <a href={"https://www.lrv.be"} target={"_blank"}>
              <IonButton size="large">
                <IonIcon name="link"/>
              </IonButton>
            </a>
            <a href={"https://www.facebook.com/LandelijkeRijverenigingen/?ref=br_rs"} target={"_blank"}>
              <IonButton size="large">
                <IonIcon name="logo-facebook"/>
              </IonButton>
            </a>
            <a href={"https://www.instagram.com/lrv_landelijkerijverenigingen"} target={"_blank"}>
              <IonButton size="large">
                <IonIcon name="logo-instagram"/>
              </IonButton>
            </a>
          </div>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutTheAppPage);
